import { UserMessageStatus } from "../core/global";
import { ApiResponse, err, getAxios, postAxios, processError, res } from "./axios";

export const getAllUserMessages = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/messages/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, `Error retrieving user's messages.`)
    return err(message, status)
  }
}

interface UpdateUserMessageProps {
  id: number | string
  status: UserMessageStatus
}

export const updateUserMessage = async ({
  id,
  status,
}: UpdateUserMessageProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/messages/update-user-message/`, {
      id,
      status,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error updating user message status.")
    return err(message, status)
  }
}